import React from "react";

function ReservationGridLoading(props) {
  const { children } = props;

  return <>{children}</>;
}

export default ReservationGridLoading;
